angular.module('eStories.grid-6-carousel.compnt', [
    'eStories.common.directives',
    'eStories.carousel.service',
    'eStories.catalog.model',
    'eStories.compnt.starRating',
    'eStories.compnt.grid'
])


    .component('sixCarousel', {
        transclude: true,
        bindings: {
            data: '<',
            section: '<'
        },

        /*data is only valid for grid-carousel*/
        controller: 'CarouselSixCtrl',
        controllerAs: 'carouselSixCtrl',
        templateUrl: 'components/templates/carousels/6-grid-carousel/grid-6-carousel.tmpl.html'
    })


    .controller('CarouselSixCtrl', [
        '$window',
        '$rootScope',
        '$scope',
        '$state',
        'CarouselService',
        function ($window,
                  $rootScope,
                  $scope,
                  $state,
                  CarouselService) {

            this.currentState = $state.current.name;

            this.getAudiobookObj = book => CarouselService.getAudiobookObj(book);

            this.getFirstPanelBook = () => {
                let bookArray = this.pagination.getPanelData();
                if (!bookArray.length) {
                    return;
                }
                return bookArray[0].audiobook;
            };

            this.getLastPanelBook = () => {
                let bookArray = this.pagination.getPanelData();
                if (!bookArray.length) {
                    return;
                }
                return bookArray[bookArray.length - 1].audiobook;
            };

            this.getMiddlePanelBooks = () => {
                let bookArray = this.pagination.getPanelData();
                if (!bookArray.length) {
                    return;
                }
                return bookArray.slice(1, 5);
            };

            const panelLength = 6;
            //noinspection JSUnusedGlobalSymbols
            this.$onChanges = (changes) => {
                this.data = changes.data.currentValue;
                this.pagination = new CarouselPagination(this.data, panelLength, $window);
            };
            this.pagination = new CarouselPagination(this.data, panelLength, $window);
        }
    ]);
